import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.sol');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Terminal } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { WebLinksAddon } from '@xterm/addon-web-links';
import { TranslateService } from '@ngx-translate/core';

function createSpringSocket(path: string) {
    const handlers: { [event: string]: Array<(data?: any) => void> } = {};
    let pending: string[] = [];
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const socket = new WebSocket(`${protocol}//${window.location.host}${path}`);
    const dispatch = (event: string, data: any) => {
        for (const handler of handlers[event] || []) handler(data);
    };
    socket.onopen = () => {
        for (const message of pending.splice(0)) socket.send(message);
        dispatch('connect', {});
    };
    socket.onmessage = (message: MessageEvent) => {
        try {
            const envelope = JSON.parse(String(message.data || '{}'));
            if (envelope?.event) dispatch(String(envelope.event), envelope.data || {});
        } catch (error) {
            dispatch('connect_error', { message: 'Invalid Spring WebSocket response' });
        }
    };
    socket.onerror = () => dispatch('connect_error', { message: 'Spring WebSocket connection failed' });
    socket.onclose = () => dispatch('disconnect', {});
    return {
        on: (event: string, handler: (data?: any) => void) => {
            if (!handlers[event]) handlers[event] = [];
            handlers[event].push(handler);
        },
        emit: (event: string, data: any = {}) => {
            const message = JSON.stringify({ event, data });
            if (socket.readyState === WebSocket.OPEN) socket.send(message);
            else if (socket.readyState === WebSocket.CONNECTING) pending.push(message);
        },
        close: () => {
            pending = [];
            if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) socket.close();
        },
    };
}

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-sol',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.sol/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100vh;
  min-height: 0;
  background: #000;
  color: #e4e4e7;
}

.sol-shell {
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}

.sol-terminal-pane {
  background: #000;
}

:host ::ng-deep .xterm {
  height: 100%;
}

:host ::ng-deep .xterm-screen {
  outline: none;
}

:host ::ng-deep .xterm-viewport {
  background-color: #000 !important;
}`],
})
export class PageKieraSolComponent implements OnInit, OnDestroy {
    @ViewChild('solTerminal') solTerminalEl: ElementRef;

    public nodeId: number = 0;
    public nodeName: string = '';
    public solSocket: any = null;
    public solTerm: any = null;
    public solFit: any = null;
    public solConnected: boolean = false;
    public solConnecting: boolean = false;
    public solRoom: string = '';
    public solError: string = '';
    public solStatus: string = 'Disconnected';
    public solState: string = 'closed';
    public solStateChangedAt: string = '';
    public solStateEvents: any[] = [];
    public bmcIp: string = '';
    private resizeObserver: any = null;
    private manualDisconnect: boolean = false;
    private solAutoRetryCount: number = 0;
    private solNoOutputTimer: any = null;
    private solSawSerialPayload: boolean = false;
    private solSessionId: string = '';
    private solInputSubscription: any = null;
    private fitTimer: any = null;
    private lastResizeKey: string = '';
    private handleWindowClose = () => {
        this.disconnectSOL();
    };

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.allow('/access') === false) return;

        this.nodeId = parseInt(WizRoute.segment.nodeId) || 0;
        this.nodeName = new URLSearchParams(window.location.search).get('name') || `Node #${this.nodeId}`;
        document.title = `SOL - ${this.nodeName}`;

        await this.service.render();

        window.addEventListener('beforeunload', this.handleWindowClose);
        window.addEventListener('pagehide', this.handleWindowClose);

        setTimeout(() => {
            this.initTerminal();
            this.connectSOL();
        }, 200);
    }

    ngOnDestroy() {
        window.removeEventListener('beforeunload', this.handleWindowClose);
        window.removeEventListener('pagehide', this.handleWindowClose);
        this.disconnectSOL();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }

    private initTerminal() {
        if (!this.solTerminalEl || !this.solTerminalEl.nativeElement) return;
        if (this.solTerm) return;

        const el = this.solTerminalEl.nativeElement;
        const term = new Terminal({
            allowTransparency: false,
            cursorBlink: true,
            cursorStyle: 'block',
            convertEol: false,
            fontSize: 15,
            fontFamily: "'Cascadia Mono', 'Cascadia Code', 'Fira Code', Menlo, Consolas, monospace",
            fontWeight: '400',
            fontWeightBold: '700',
            lineHeight: 1.05,
            letterSpacing: 0,
            minimumContrastRatio: 4.5,
            macOptionIsMeta: true,
            rightClickSelectsWord: true,
            scrollback: 20000,
            scrollSensitivity: 2,
            tabStopWidth: 8,
            theme: {
                background: '#000000',
                foreground: '#f4f4f5',
                cursor: '#ffffff',
                cursorAccent: '#000000',
                selectionBackground: '#3f3f46',
                black: '#000000',
                red: '#ef4444',
                green: '#22c55e',
                yellow: '#f59e0b',
                blue: '#38bdf8',
                magenta: '#d946ef',
                cyan: '#06b6d4',
                white: '#f4f4f5',
                brightBlack: '#71717a',
                brightRed: '#f87171',
                brightGreen: '#4ade80',
                brightYellow: '#fbbf24',
                brightBlue: '#7dd3fc',
                brightMagenta: '#e879f9',
                brightCyan: '#22d3ee',
                brightWhite: '#ffffff',
            }
        });
        const fit = new FitAddon();
        term.loadAddon(new WebLinksAddon());
        term.loadAddon(fit);

        term.open(el);
        this.solTerm = term;
        this.solFit = fit;
        this.scheduleTerminalFit(false, true);

        this.writeStatus(`KiERA SOL Console - ${this.nodeName}`);
        this.writeStatus('Connecting...');

        this.resizeObserver = new ResizeObserver(() => {
            this.scheduleTerminalFit(true);
        });
        this.resizeObserver.observe(el);
        window.setTimeout(() => this.scheduleTerminalFit(true, true), 250);
    }

    public fitTerminal(sendResize: boolean = true, focus: boolean = true) {
        if (!this.solFit || !this.solTerm) return;
        try {
            this.solFit.fit();
            if (focus) this.solTerm.focus();
            this.emitTerminalResize(sendResize);
        } catch (e) {
            console.warn('SOL terminal fit failed', e);
        }
    }

    private scheduleTerminalFit(sendResize: boolean = true, focus: boolean = false) {
        if (this.fitTimer) window.clearTimeout(this.fitTimer);
        this.fitTimer = window.setTimeout(() => {
            this.fitTimer = null;
            this.fitTerminal(sendResize, focus);
        }, 40);
    }

    private currentTerminalSize() {
        return {
            cols: Math.max(20, this.solTerm?.cols || 100),
            rows: Math.max(10, this.solTerm?.rows || 30),
        };
    }

    private emitTerminalResize(sendResize: boolean = true) {
        if (!sendResize || !this.solSocket || !this.solTerm || !this.solConnected) return;
        const dims = this.currentTerminalSize();
        const key = `${dims.cols}x${dims.rows}`;
        if (key === this.lastResizeKey) return;
        this.lastResizeKey = key;
        this.solSocket.emit('sol_resize', dims);
    }

    private writeStatus(message: string, color: string = '36') {
        if (!this.solTerm) return;
        this.solTerm.writeln(`\x1b[${color}m[SOL]\x1b[0m ${message}`);
    }

    private setSolState(state: string, message: string = '', detail: string = '') {
        const nextMessage = message || this.getSolStateLabel(state);
        if (this.solState === state && this.solStatus === nextMessage) return;
        const changedAt = new Date().toISOString();
        this.solState = state;
        this.solStatus = nextMessage;
        this.solStateChangedAt = changedAt;
        this.solStateEvents.unshift({ state, message: nextMessage, detail, created: changedAt });
        this.solStateEvents = this.solStateEvents.slice(0, 80);
        void this.recordSolState(state, nextMessage, detail);
    }

    private async recordSolState(state: string, message: string, detail: string = '') {
        if (!this.nodeId || !this.solSessionId) return;
        try {
            await wiz.call('record_event', {
                data: JSON.stringify({
                    node_id: this.nodeId,
                    session_id: this.solSessionId,
                    state,
                    message,
                    detail,
                })
            });
        } catch (e) {
            console.warn('SOL state event record failed', e);
        }
    }

    public getSolStateLabel(state: string = this.solState): string {
        const labels: any = {
            'socket-connected': 'socket-connected',
            'sol-activating': 'sol-activating',
            'sol-operational': 'sol-operational',
            'receiving-serial': 'receiving-serial',
            'waiting-serial': 'waiting-serial',
            'error': 'error',
            'closed': 'closed',
            'disconnected': 'disconnected',
        };
        return labels[state] || state || 'closed';
    }

    public getSolStateBadgeClass(state: string = this.solState): string {
        switch (state) {
            case 'receiving-serial':
                return 'bg-emerald-900 text-emerald-300';
            case 'sol-operational':
                return 'bg-cyan-900 text-cyan-300';
            case 'waiting-serial':
                return 'bg-amber-900 text-amber-300';
            case 'socket-connected':
            case 'sol-activating':
                return 'bg-blue-900 text-blue-300';
            case 'error':
                return 'bg-red-900 text-red-300';
            case 'disconnected':
            case 'closed':
                return 'bg-zinc-700 text-zinc-400';
            default:
                return 'bg-zinc-700 text-zinc-400';
        }
    }

    public async connectSOL() {
        if (!this.nodeId) {
            this.solError = this.translate.instant('page.sol.error_node_id_missing');
            await this.service.render();
            return;
        }

        const randomStr = (len: number) => {
            const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < len; i++) result += chars.charAt(Math.floor(Math.random() * chars.length));
            return result;
        };
        this.solRoom = `sol_${this.nodeId}_${randomStr(8)}`;
        this.solSessionId = `${this.solRoom}_${Date.now()}`;
        this.solConnecting = true;
        this.manualDisconnect = false;
        this.solError = '';
        this.setSolState('sol-activating', 'Opening socket');
        this.bmcIp = '';
        await this.service.render();

        const socket = createSpringSocket('/ws/sol');
        this.solSocket = socket;

        socket.on('connect', () => {
            this.setSolState('socket-connected', 'Socket connected');
            if (this.solTerm) this.writeStatus('Socket connected, opening BMC SOL session...');
            void this.service.render();
            socket.emit('join', { room: this.solRoom });
            this.fitTerminal(false, true);
            const dims = this.currentTerminalSize();
            this.setSolState('sol-activating', 'Opening BMC SOL session');
            socket.emit('sol_connect', {
                node_id: this.nodeId,
                room: this.solRoom,
                ...dims
            });
        });

        socket.on('connect_error', async (error: any) => {
            this.solConnecting = false;
            this.solConnected = false;
            this.solError = error?.message || 'Socket connection failed';
            this.setSolState('error', 'Socket connection failed', this.solError);
            this.writeStatus(this.solError, '31');
            await this.service.render();
        });

        socket.on('sol_status', async (data: any) => {
            this.setSolState('sol-activating', data.message || 'Activating SOL');
            if (this.solTerm && data.message) this.writeStatus(data.message, '33');
            await this.service.render();
        });

        socket.on('sol_connected', async (data: any) => {
            this.solConnected = true;
            this.solConnecting = false;
            this.bmcIp = data.bmc_ip || '';
            this.solSawSerialPayload = false;
            this.setSolState('sol-operational', data.message || 'SOL session operational');
            if (this.solTerm) {
                this.writeStatus(`Connected to ${data.bmc_ip}`, '32');
            }
            this.scheduleTerminalFit(true, true);
            this.scheduleNoOutputNotice();
            window.setTimeout(() => {
                if (this.solSocket === socket && this.solConnected && !this.solSawSerialPayload) {
                    this.forwardSolInput('\r');
                }
            }, 300);
            await this.service.render();
        });

        socket.on('sol_output', (data: any) => {
            if (this.solTerm && data.output) {
                const output = String(data.output);
                this.solTerm.write(output);
                if (!output.toLowerCase().includes('sol session operational')) {
                    this.solSawSerialPayload = true;
                    this.setSolState('receiving-serial', 'Receiving serial output');
                    this.clearNoOutputTimer();
                    void this.service.render();
                }
            }
        });

        socket.on('sol_error', async (data: any) => {
            const message = data.message || 'SOL connection failed';
            if (this.shouldAutoRetrySol(message)) {
                this.solAutoRetryCount++;
                this.solConnecting = true;
                this.solConnected = false;
                this.setSolState('sol-activating', 'Retrying SOL connection', message);
                if (this.solTerm) this.writeStatus(`Retrying after transient SOL error: ${message}`, '33');
                if (this.solSocket) {
                    this.solSocket.emit('sol_disconnect', {});
                    this.solSocket.close();
                    this.solSocket = null;
                }
                await this.service.render();
                setTimeout(() => this.connectSOL(), 1500);
                return;
            }
            this.solConnecting = false;
            this.solConnected = false;
            this.solError = message;
            this.setSolState('error', message);
            if (this.solTerm) {
                this.writeStatus(`Error: ${this.solError}`, '31');
            }
            await this.service.render();
        });

        socket.on('sol_exit', async (data: any) => {
            this.solConnected = false;
            this.solConnecting = false;
            this.setSolState('closed', data?.message || 'SOL session ended.');
            if (this.solTerm) {
                this.writeStatus(data?.message || 'SOL session ended.', '33');
            }
            await this.service.render();
        });

        socket.on('sol_disconnected', async () => {
            this.solConnected = false;
            this.solConnecting = false;
            this.setSolState('disconnected', 'SOL session disconnected');
            await this.service.render();
        });

        socket.on('disconnect', async () => {
            this.solConnected = false;
            this.solConnecting = false;
            this.setSolState('disconnected', this.manualDisconnect ? 'Disconnected' : 'Socket disconnected');
            if (!this.manualDisconnect) this.writeStatus('Socket disconnected. Use Reconnect to open a new SOL session.', '33');
            await this.service.render();
        });

        this.attachSolInputHandler();
    }

    public async reconnectSOL() {
        this.solAutoRetryCount = 0;
        this.disconnectSOL();
        await this.service.render();
        setTimeout(() => {
            this.initTerminal();
            this.connectSOL();
        }, 350);
    }

    public disconnectSOL() {
        this.manualDisconnect = true;
        this.solAutoRetryCount = 0;
        this.solSawSerialPayload = false;
        this.clearNoOutputTimer();
        if (this.fitTimer) {
            window.clearTimeout(this.fitTimer);
            this.fitTimer = null;
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        if (this.solInputSubscription) {
            try {
                this.solInputSubscription.dispose();
            } catch (e) {
                console.warn('SOL input subscription cleanup failed', e);
            }
            this.solInputSubscription = null;
        }
        if (this.solSocket) {
            this.solSocket.emit('sol_disconnect', {});
            this.solSocket.close();
            this.solSocket = null;
        }
        this.solConnected = false;
        this.solConnecting = false;
        this.setSolState('disconnected', 'Disconnected');
        if (this.solTerm) {
            this.solTerm.dispose();
            this.solTerm = null;
            this.solFit = null;
        }
        this.lastResizeKey = '';
    }

    private attachSolInputHandler() {
        if (!this.solTerm) return;
        if (this.solInputSubscription) {
            try {
                this.solInputSubscription.dispose();
            } catch (e) {
                console.warn('SOL input subscription cleanup failed', e);
            }
        }
        this.solInputSubscription = this.solTerm.onData((data: string) => {
            this.forwardSolInput(data);
        });
    }

    private canForwardSolInput(): boolean {
        return Boolean(this.solSocket && !this.manualDisconnect && this.solConnected);
    }

    private forwardSolInput(input: string) {
        if (!input || !this.canForwardSolInput()) return;
        this.solSocket.emit('sol_input', { input });
    }

    public sendSolKey(key: string) {
        const sequences: any = {
            f2: '\x1bOQ',
            f8: '\x1b[19~',
            f11: '\x1b[23~',
            f12: '\x1b[24~',
            esc: '\x1b',
            del: '\x1b[3~',
            enter: '\r',
        };
        const sequence = sequences[String(key || '').toLowerCase()];
        if (!sequence) return;
        if (this.solTerm) this.solTerm.focus();
        this.forwardSolInput(sequence);
    }

    private shouldAutoRetrySol(message: string): boolean {
        if (this.manualDisconnect || this.solAutoRetryCount >= 1) return false;
        const lowered = String(message || '').toLowerCase();
        return [
            'invalid command',
            'already in use',
            'payload disabled',
            'unable to establish',
            'connection timed out',
            'already active',
            'session already',
        ].some(marker => lowered.includes(marker));
    }

    private scheduleNoOutputNotice() {
        this.clearNoOutputTimer();
        this.solNoOutputTimer = setTimeout(async () => {
            if (!this.solConnected || !this.solTerm || this.solSawSerialPayload) return;
            this.setSolState('waiting-serial', 'Waiting for serial output');
            this.writeStatus('No serial payload received yet. If the node is booting, check BIOS serial redirection and kernel console settings.', '33');
            await this.service.render();
        }, 30000);
    }

    private clearNoOutputTimer() {
        if (this.solNoOutputTimer) {
            clearTimeout(this.solNoOutputTimer);
            this.solNoOutputTimer = null;
        }
    }
}

export default PageKieraSolComponent;
